import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "@/lib/utils";
import { useCalculatorTheme } from "@/contexts/CalculatorThemeContext";

const CalculatorLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => {
  // Try to use theme context, fallback to dark if not available
  let isDark = true;
  try {
    const theme = useCalculatorTheme();
    isDark = theme.isDark;
  } catch {
    // Component is used outside of CalculatorThemeProvider, default to dark
  }

  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 transition-colors duration-300",
        isDark ? "text-white/70" : "text-slate-600",
        className
      )}
      {...props}
    />
  );
});
CalculatorLabel.displayName = "CalculatorLabel";

export { CalculatorLabel };
